import { AppHeader, AnonymousAppContent, AppFooter } from '../components/index'

const AnonymousLayout = () => {
  return (
    <div>
      <div className="wrapper d-flex flex-column min-vh-100 bg-light">
        <AppHeader />
        <div className="body flex-grow-1 px-3">
          <AnonymousAppContent />
        </div>
        <AppFooter />
      </div>
    </div>
  )
}

export default AnonymousLayout
